import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import util from "./utils";
import "vant/lib/index.css";

Vue.config.productionTip = false;
Vue.prototype.$util = util;

router.beforeEach((to, from, next) => {
  // const token = util.getStore("token");
  document.title = to.meta.title
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    next();
  } else {
    next();
  }
});
// new Vconsole();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
